// import "babel-polyfill";
import 'regenerator-runtime/runtime'


import './css/main.scss';
import * as React from 'react';
import ReactDOM from 'react-dom';
import { DigitalCampaign4a } from './components/DigitalCampaign4a';

// const container = document.getElementsByClassName('main-container')[0];
// container.innerHTML = '';
const container = document.getElementById('santander_react_container')
ReactDOM.render(
    <DigitalCampaign4a />,
    container,
)